// extracted by css-extract-rspack-plugin
export default {"pusherAvatar":"Pusher-module__pusherAvatar__jXMgE","pusherLink":"Pusher-module__pusherLink__bO6XG"};